import React from 'react';
import PropTypes from 'prop-types';
import RsProjectTableItem from '@Pages/RetroSynthesis/RetroSynthesisProjects/components/RsProjectTableItem';
import RsProjectTableGroup from '@Pages/RetroSynthesis/RetroSynthesisProjects/components/RsProjectTableGroup';

function ProjectTableItemWrapper({ project, ...props }) {
  const { childProjects } = project;
  if (childProjects && childProjects.length) {
    return <RsProjectTableGroup project={project} childProjects={childProjects} {...props} />;
  }
  return <RsProjectTableItem id={project.id} project={project} {...props} />;
}

ProjectTableItemWrapper.propTypes = {
  project: PropTypes.object.isRequired,
};

export default ProjectTableItemWrapper;
